const TOKEN_KEY = 'admin_token';

export function setToken(token) {
    localStorage.setItem(TOKEN_KEY, token);
}

export function getToken() {
    // 确保这里的逻辑不会返回 null 或 undefined
    const token = localStorage.getItem(TOKEN_KEY);
    return token ? token.trim() : ''; // 防止 null
}

export function removeToken() {
    localStorage.removeItem(TOKEN_KEY);
}
